import * as actions from '../../redux/actions';

import React, { Component, useState } from 'react';

import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import GoogleMapReact from 'google-map-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import { setOperatorSite } from '../../../home/redux/setOperatorSite';

const offices = [
  { name: 'santiago' },
  { name: 'talc' },
  { name: 'temocu' },
  { name: 'puerto montt' },
  { name: 'osorno' },
  { name: 'calbuco' },
  { name: 'valdivia' },
];

const services = [
  { name: 'Santiago' },
  { name: 'Talc' },
  { name: 'Temocu' },
  { name: 'Puerto montt' },
  { name: 'Osorno' },
  { name: 'Calbuco' },
];

const AnyReactComponent = ({ text }) => <div>{text}</div>;

const iframe =
  '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48488.78227166322!2d-73.1691502871581!3d-40.573638117083725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9616367d12e3d8d5%3A0xa1eeda2f4774e6f4!2sOsorno%2C%20Los%20Lagos%2C%20Chile!5e0!3m2!1sen!2sin!4v1640618617323!5m2!1sen!2sin" width="700" height="350" style="border:0;" allowfullscreen="" loading="lazy"></iframe>';

function Iframe(props) {
  return <div dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : '' }} />;
}

export const OfficesList3 = props => {
  const [selectedOffice, setSelectedOffice] = useState(props.officeLocations[0]);

  // const renderOpertaorServices = () => {
  //   return services.map(service => {
  //     return (
  //       <div className="service-item lh-1-3">
  //         <div style={{ height: 2, width: 8, backgroundColor: props.operator && props.operator.color_codes.secondary_color ? props.operator.color_codes.secondary_color : '', marginRight: 5 }}></div>
  //         <span className="font11">{service.name}</span>
  //       </div>
  //     );
  //   });
  // };
  console.log('selected office is', selectedOffice);

  return (
    <div className="themes-offices">
      <div className="new-container ">
        <h1 className="font20 bold mb5" style={{ marginBottom: 30 }}>
          Oficinas
        </h1>
        <div className="offices">
          <ul className="office__list " style={{ background: '#1B50B3' }}>
            {props.officeLocations.map((item, index) => (
              // <>
              <li
                onClick={() => setSelectedOffice(item)}
                // style={{background:'red'}}
                className={` cursor-pointer  office__item  ${
                  item.city === selectedOffice.city ? ' bold' : ' '
                } `}
                style={{
                  color: item.city === selectedOffice.city ? props.operator.background_color : '',
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <span className=" font12">{item.city}</span>
              </li>
              // </>
            ))}
          </ul>
          <div className="office__map">
            <div style={{ width: '65%', position: 'relative' }}>
              {/* <div style={{height:100, width:300, background:"#fff",position:'absolute',zIndex:1000, top:10, left:10 }}>
              {AnyReactComponent}
              </div>
              
                <GoogleMapReact
                  bootstrapURLKeys={{ key: AppData.MAP_API_KEY }}
                  defaultCenter={{
                    // lat: parseFloat(selectedOffice.latitude),
                    // lng: parseFloat(selectedOffice.longitude),
                    lat: 59.955413,
                     lng: 30.337844,
                  }}
                  defaultZoom={11}
                  // options={{
                  //   styles: [{background:"green"}]
                  // }}
                  options={{ styles }}
                >
                  <AnyReactComponent lat={59.955413} lng={30.337844} text={'Kreyser Avrora'} />
                </GoogleMapReact> */}
              <Iframe iframe={iframe} />
            </div>
            <div
              style={{
                width: '35%',
                background: props.operator.background_color,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <div
                className="office__map-details-text  font10 bold"
                style={{ paddingLeft: 50, paddingRight: 30, lineHeight: 1.4 }}
              >
                <img
                  src={getIcons('Destination', props.operator)}
                  alt=""
                  style={{ width: 10, marginRight: 5 }}
                />
                <span className="selected-location-name " style={{ textTransform: 'uppercase' }}>
                  {selectedOffice.office[0].address}
                </span>

                <div>
                  <span className="selected-location-contact-no">
                    {selectedOffice.office[0].phone}
                  </span>
                  {/* <br />
                    <span className="selected-location-address">{selectedOffice.address}</span> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = [
  { position: 'relative' },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
];

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OfficesList3);



// WEBPACK FOOTER //
// ./src/features/themes/common/OfficeList/OfficesList3.js